<script>
import { mapActions } from "vuex";

export default {

  data() {
    return {
      formData: {},
      registerActive: false,
      showPassword: false,
      resetMail: "",
      resetPasswordModal: false,

      clickedLogin: false
    };
  },

  computed: {
    mailValidation() {
      const hasSpecialChar = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.resetMail);
      const isValidLength = (this.resetMail.length > 4);
      return hasSpecialChar && isValidLength;
    },

    parentDomain() {
      return process.env.VUE_APP_SHARED_PARENT_DOMAIN;
    }
  },

  methods: {
    ...mapActions('app', [
      'retrieveToken'
    ]),

    ...mapActions('settings', [
      'sendResetPasswordMail'
    ]),

    logoutTime() {
      const d1 = new Date();
      const d2 = new Date(d1);
      let ms = d2.setMinutes(
        d1.getMinutes() + parseInt(process.env.VUE_APP_SESSION_TIMEOUT)
      );
      localStorage.setItem('logoutTime', ms);
    },

    loginAction() {
      let params = {
        username: this.formData.userName,
        userpwd: this.formData.password,
      };

      if (this.clickedLogin == false) {
        this.retrieveToken(params)
          .then(async (response) => {
            this.clickedLogin = true;
            localStorage.setItem("company_name", response.data.company_name);
            sessionStorage.setItem("user_email", this.formData.userName);

            if (response.data.company_licence) {
              if (response.data.company_licence.plan_id === -1) {
                this.$router.push("/audited-companies");
              } else {
                this.$router.push("/apps");
              }
            }

            this.logoutTime();
            this.$notify('success', this.$t('login.loginSuccessful'), true);
            this.setAllCookies();
          })
          .catch(({ response }) => {
            this.$notify('error', response.data.messageName);
          })
      }
    },

    setAllCookies() {
      const setLogoutTime = () => {
        const date = new Date();
        const timeout = parseInt(process.env.VUE_APP_SESSION_TIMEOUT);
        date.setMinutes((date.getMinutes()) + timeout);
        return date.toUTCString();
      }

      const setCookies = () => {
        const logoutTime = setLogoutTime();

        if (this.parentDomain != "localhost") {
          document.cookie = `username=${localStorage.username}; domain=${this.parentDomain}; expires=${logoutTime}; path=/`;
          document.cookie = `firstname=${localStorage.firstname}; domain=${this.parentDomain}; expires=${logoutTime}; path=/`;
          document.cookie = `surname=${localStorage.surname}; domain=${this.parentDomain}; expires=${logoutTime}; path=/`;
          document.cookie = `access_token=${localStorage.access_token}; domain=${this.parentDomain}; expires=${logoutTime}; path=/`;
          document.cookie = `expire_date=${logoutTime}; domain=${this.parentDomain}; expires=${logoutTime}; path=/`;
        } else {
          document.cookie = `username=${localStorage.username}; expires=${logoutTime}; path=/`;
          document.cookie = `firstname=${localStorage.firstname}; expires=${logoutTime}; path=/`;
          document.cookie = `surname=${localStorage.surname}; expires=${logoutTime}; path=/`;
          document.cookie = `access_token=${localStorage.access_token}; expires=${logoutTime}; path=/`;
          document.cookie = `expire_date=${logoutTime}; expires=${logoutTime}; path=/`;
        }
      }

      setCookies();
    },

    openResetPopup() {
      if (this.$refs.resetPasswordPopup) {
        this.$refs.resetPasswordPopup.openPopup();
      }
    },

    sendResetPassword() {
      if (!this.mailValidation) return;

      const params = {
        reset: true,
        email: this.resetMail
      };

      this.sendResetPasswordMail(params)
        .then(res => {
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });

          this.resetPasswordModal = false;

          if (this.$refs.resetPasswordPopup) {
            this.$refs.resetPasswordPopup.closePopup();
          }
          this.resetMail = "";
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    }
  },
};
</script>

<template>
  <div class="login-page">
    <div class="login-container">
      <div class="container-row" style="width: 75%">
        <div class="responsive-col">
          <div class="login-card" style="background-color: transparent">
            <img style="padding: 25px" src="/images/sustainfinity-logo.png" alt="sustainfinity-logo" />
            <form @submit.prevent="loginAction()" autocomplete="on">
              <input autocomplete="username" type="text" v-model="formData.userName" class="custom-input"
                id="login-username-form" :placeholder="$t('login.username')" />

              <br />

              <div class="input-container">
                <input autocomplete="current-password" v-model="formData.password"
                  :type="showPassword ? 'text' : 'password'" class="custom-input password-input" id="login-userpwd-form"
                  :placeholder="$t('login.password')" required aria-describedby="basic-addon2" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>

              <a href="#" class="forget-password" @click.prevent="openResetPopup()">
                {{ $t("login.forgotPassword") }}
              </a>

              <br />
              <button id="login-proceed-button" class="login-btn" type="submit" :disabled="clickedLogin">
                {{ $t("login.login") }}
              </button>
            </form>
          </div>

          <p class="cookie-paragraph" style="color: var(--sustainfinity-navy);">
            {{ $t('register.initial_warning.1') }}
          </p>

          <p class="cookie-paragraph">
            {{ $t('login.cookies_warning') }}
            <br><br>
            <b>{{ $t('login.thank_you') }}</b>
          </p>
        </div>
      </div>
    </div>


    <sust-popup ref="resetPasswordPopup" v-model="resetPasswordModal" size="sm" :title="$t('login.passwordReset')"
      :footer="false">
      <div class="popup-content">
        <input v-model="resetMail" type="email" placeholder="Email" class="custom-input" />
        <div class="button-container">
          <button class="send-btn" :disabled="!mailValidation" @click="sendResetPassword">
            {{ $t("login.send") }}
          </button>
        </div>
      </div>
    </sust-popup>


  </div>

</template>

<style scoped>
.login-container {
  position: fixed;
  top: 52%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 50vw;
  max-width: 600px;
  min-width: 300px;
}


.responsive-col {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.login-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  padding: 16px;
  margin-bottom: 48px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.login-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #61a60e;
  color: white;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-btn:hover {
  background-color: #218838;
}

.custom-input {
  width: 100%;
  padding: .375rem .75rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #ced4da;
  color: #495057;
  border-radius: 4px;
  outline: none;
  margin-bottom: 10px;
  transition: border-color 0.7s ease, box-shadow 0.7s ease;

}

.custom-input:focus {
  border-color: #0383ab;
  box-shadow: 0 0 5px 2px rgba(116, 177, 243, 0.973);
}

.login-page {
  position: relative;
}

.input-container {
  position: relative;
  width: 100%;

}

.forget-password {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.password-input {
  padding-right: 40px;
}

.popup-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
}

.send-btn {
  background-color: #61a60e;
  color: white;
  font-weight: 800;
  text-transform: uppercase;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border: 2px solid transparent;

}

.send-btn:hover {
  background-color: #218838;
}

.send-btn:disabled {
  background-color: #d4d4d4;
  cursor: not-allowed;
  border: 2px solid #93d3a2;
}

.password-icon-container {
  position: absolute;
  z-index: 10;
  right: .75em;
  top: 40%;
  transform: translateY(-50%);
}

.show-password-icon:hover {
  cursor: pointer;
  filter: brightness(125%);
  z-index: 99;
}

.cookie-paragraph {
  font-size: .85em;
  font-style: italic;
  color: gray;
  padding: 0 1.5em 0 1.5em;
}

@media (min-width: 576px) {
  .responsive-col {
    width: 100%;
  }
}

@media (min-width: 992px) {
  .responsive-col {
    width: 100%;

  }
}
</style>